import { TypographyProps } from "@mui/material";
import { useEffect, useState } from "react";

import { Box } from "@/Components/v2/atoms/Box";
import { Typography } from "@/Components/v2/atoms/Typography";

type WordByWordLoaderProps = {
  words?: string[];
  interval?: number;
  minOpacity?: number;
  typographyProps?: TypographyProps;
};

export const WordByWordLoader = ({
  words = ["Loading", "please", "wait", "..."],
  interval = 1000,
  minOpacity = 0,
  typographyProps,
}: WordByWordLoaderProps) => {
  const [visibleWordCount, setVisibleWordCount] = useState(0);

  useEffect(() => {
    // Show one more word at a time until all words are visible, then reset
    const intervalId = setInterval(() => {
      setVisibleWordCount((prev) => {
        // When all words are visible, reset to 0 to restart animation
        if (prev >= words.length) {
          return 0;
        }
        return prev + 1;
      });
    }, interval);

    return () => clearInterval(intervalId);
  }, [words.length, interval]);

  return (
    <Typography variant="body2" color="primary" {...typographyProps}>
      {words.map((word, index) => (
        <Box
          key={index}
          component="span"
          sx={{
            transition: "opacity 0.5s ease-in-out",
            opacity: index < visibleWordCount ? 1 : minOpacity,
            marginRight: index < words.length - 1 ? "0.35em" : 0,
          }}
        >
          {word}
        </Box>
      ))}
    </Typography>
  );
};
